// extracted by mini-css-extract-plugin
module.exports = {"page":"OurStory_page__qhnLv","content":"OurStory_content__faMaZ","closing":"OurStory_closing__LdU_s"};